import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo, useCallback } from 'react';
import Button, { ButtonIconSize, ButtonVariant, ButtonColor } from '../button/Button';
import { SymbolDirection } from '../symbol/Symbol';
import * as styles from './Pagination.style';
import { paginator, getPages } from './paginator/paginator';
import { ICON_CHEVRON } from '../../icons';
export const Pagination = _ref => {
  let {
    current,
    currentPageAround = 1,
    totalItems,
    loading,
    pageSize,
    buildPagePath,
    navigateTo,
    dataRef = 'pagination',
    ...rest
  } = _ref;
  const pagination = useMemo(() => paginator(totalItems, pageSize, current), [totalItems, pageSize, current]);
  const handleClick = useCallback(page => () => {
    if (page) {
      navigateTo(page);
    }
  }, [navigateTo]);
  const pages = useMemo(() => getPages(current, pagination.totalPages, currentPageAround), [current, pagination, currentPageAround]);
  if (pagination.totalPages === 0 || pagination.totalPages === 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    "data-ref": dataRef
  }, rest, {
    $_css: styles.base
  }), /*#__PURE__*/React.createElement(Button, {
    icon: ICON_CHEVRON,
    iconDirection: SymbolDirection.LEFT,
    iconSize: ButtonIconSize.BIG,
    variant: ButtonVariant.OUTLINE,
    color: ButtonColor.DARK,
    disabled: pagination.isFirstPage || loading,
    onClick: handleClick(pagination.previousPage),
    dataRef: `${dataRef}-prev-button`,
    title: "Vai alla pagina precedente"
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.status
  }, current), /*#__PURE__*/React.createElement(_StyledNav, {
    $_css3: styles.nav
  }, /*#__PURE__*/React.createElement("ul", null, pages.map((page, i) => {
    if (!page) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("li", {
          key: `break-${i}`
        }, /*#__PURE__*/React.createElement(_StyledDiv3, {
          $_css4: styles.points
        }, "..."))
      );
    }
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: `page-${page.index}`,
      $active: page.active,
      $_css5: styles.page
    }, /*#__PURE__*/React.createElement(Button, {
      label: page.index.toString(),
      variant: ButtonVariant.LIGHT,
      color: page.active ? ButtonColor.DARK : ButtonColor.NEUTRAL,
      expanded: true,
      autoWidth: true,
      onClick: !page.active ? handleClick(page.index) : undefined,
      href: buildPagePath && !page.active ? buildPagePath(page.index) : undefined,
      dataRef: `${dataRef}-page-${page.index}`,
      title: `Vai a pagina ${page.index}`
    }));
  }))), /*#__PURE__*/React.createElement(Button, {
    icon: ICON_CHEVRON,
    iconDirection: SymbolDirection.RIGHT,
    iconSize: ButtonIconSize.BIG,
    variant: ButtonVariant.OUTLINE,
    color: ButtonColor.DARK,
    disabled: pagination.isLastPage || loading,
    onClick: handleClick(pagination.nextPage),
    dataRef: `${dataRef}-next-button`,
    title: "Vai alla pagina successiva"
  }));
};
export default Pagination;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Pagination___StyledDiv",
  componentId: "sc-9dguxq-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Pagination___StyledDiv2",
  componentId: "sc-9dguxq-1"
})(["", ""], p => p.$_css2);
var _StyledNav = _styled("nav").withConfig({
  displayName: "Pagination___StyledNav",
  componentId: "sc-9dguxq-2"
})(["", ""], p => p.$_css3);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Pagination___StyledDiv3",
  componentId: "sc-9dguxq-3"
})(["", ""], p => p.$_css4);
var _StyledLi = _styled("li").withConfig({
  displayName: "Pagination___StyledLi",
  componentId: "sc-9dguxq-4"
})(["", ""], p => p.$_css5);
//# sourceMappingURL=Pagination.js.map